import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';

@Injectable()
export class PackagingMaterialAttirbuteService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'Admin';

    // --------------------
    // list getters
    // --------------------
    getPackagingTypes(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPackagingTypes/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getPackagingOwners(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPackagingOwners/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getStorageConditions(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetStorageConditions/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getReturnables(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetReturnables/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getClassifications(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetClassifications/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getDispatchers(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetDispatchers/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getWashingSuppliers(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetWashingSuppliers/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getMaterialExclusions(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetMaterialExclusions/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getMainStores(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetMainStores/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getReceivers(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetReceivers/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getConsumingAreas(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetConsumingAreas/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getRegions(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetRegions/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getMaterialList(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetMaterialList/?getOnlyActive=false`)
            .map((response: Response) => <IReturnObject>response.json());
    }


    // --------------------
    // deletes
    // --------------------
    deleteClassification(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteClassification/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteConsumingarea(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteConsumingarea/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteDispatcher(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteDispatcher/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteMainstore(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteMainstore/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteMaterialtype(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteMaterialtype/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deletePackagingowner(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeletePackagingowner/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deletePackagingtype(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeletePackagingtype/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteReceiver(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteReceiver/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteRegion(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteRegion/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteReturnables(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteReturnables/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteStoragecondition(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteStoragecondition/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteWashingsupplier(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteWashingsupplier/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteMaterialexclusion(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteMaterialexclusion/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteMaterialList(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteMaterialList/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }


    // --------------------
    // updates
    // --------------------
    updateClassification(id: number, description: string, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateClassification/?id=${id}&description=${description}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateConsumingarea(id: number, description: string, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateConsumingarea/?id=${id}&description=${description}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateDispatcher(id: number, description: string, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateDispatcher/?id=${id}&description=${description}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateMainstore(id: number, description: string, supplierId: number, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateMainstore/?id=${id}&description=${description}&supplierId=${supplierId}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updatePackagingowner(id: number, description: string, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdatePackagingowner/?id=${id}&description=${description}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updatePackagingtype(id: number, description: string, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdatePackagingtype/?id=${id}&description=${description}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateRegion(id: number, description: string, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateRegion/?id=${id}&description=${description}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateReturnables(id: number, description: string, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateReturnables/?id=${id}&description=${description}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateStoragecondition(id: number, description: string, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateStoragecondition/?id=${id}&description=${description}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateWashingsupplier(id: number, description: string, supplierId: number, active: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateWashingsupplier/?id=${id}&description=${description}&supplierId=${supplierId}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateMaterialexclusion(description: string, MHNo: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/UpdateMaterialexclusion/?description=${description}&MHNo=${MHNo}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateMaterialList(id: number, description: string, co2impact: number, active: boolean): Observable<IReturnObject> {
      return this.http.get(`${this.apiUrl}/UpdateMaterialList/?id=${id}&description=${description}&co2impact=${co2impact}&active=${active}`)
            .map((response: Response) => <IReturnObject>response.json());
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-material-attributes/packaging-material-attributes.service.ts